var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentConsolidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 8.80841C12.294 8.80841 12.5882 8.85793 12.882 9.00684L14.9996 9.99964L15 3H9V10L11.1176 9.00719C11.4118 8.85794 11.7056 8.80842 11.9998 8.80842L11.9998 8.80841Z",
    fill: "#E60033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81759 21H19.1435C20.1524 21 21 20.0824 21 18.9902V5.00983C21 3.91762 20.1524 3 19.1435 3H16.3188V10.5C16.3188 10.8931 16.1169 11.2427 15.8346 11.4611C15.6733 11.5486 15.5117 11.5922 15.3099 11.5922C15.1486 11.5922 14.987 11.5486 14.8257 11.4611L13.034 10.3804C12.3986 9.99715 11.6033 9.99715 10.968 10.3804L9.17621 11.4611C8.85333 11.6358 8.49021 11.6358 8.16734 11.4611C7.84446 11.2865 7.68317 10.8931 7.68317 10.5L7.6826 3H4.85784C3.84897 3 3.00138 3.91762 3.00138 5.00983V18.9902C2.96112 20.0824 3.80872 21 4.81759 21Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentConsolidation);
export default __webpack_public_path__ + "static/media/shipment_consolidation.87d2983c19db1a84bf147a2c1b302f30.svg";
export { ForwardRef as ReactComponent };